export default __webpack_public_path__ + "static/media/boxtype18.d8798c94.JPG";